module.exports = __webpack_public_path__ + "static/media/steps-previous.f20190a0.svg";